// Typescript:
import { courseDataType } from "../../pages/details"
interface HeaderExtraDetailsType {
    id: number
    detailHeading: string
    detailDescription?: string
    bgColor: string
    fontColor: string
}

interface HeaderPropType {
    courseData: courseDataType | undefined
    scrollToContact : () => void
    
}

const Header = ({courseData, scrollToContact}: HeaderPropType) => {
    // Constants:
    const headerExtraDetails = [
        {
            id:0,
            detailHeading: `${courseData?.duration} + hrs to complete`,
            bgColor: '#D0FDE0',
            fontColor: '#0A662A',
        },
        {
            id:1,
            detailHeading: `${courseData?.experienceRequired}`,
            detailDescription: `${courseData?.experienceSubText}`,
            bgColor: '#FAE0F3',
            fontColor: '#6F0755',
        },
        {
            id:2,
            detailHeading: `${courseData?.studyMode}`,
            detailDescription: `${courseData?.studySubText}`,
            bgColor: '#DFD4FF',
            fontColor: '#2A0D7E',
        }
    ]

    return <div className='col-[2_/_3] w-full mt-[69px] grid grid-rows-[max-content] md:grid-rows-[auto_90px_90px] grid-cols-[100%] gap-[20px]'>
        <div className='md:row-[1_/_3] col-[1_/_2] w-full md:p-[32px] md:pb-[8rem] md:bg-[#FAFAFA] md:border-[2px] border-[#D8D8D8] border-solid rounded-[40px] text-center md:text-left'>
            <h2 className='text-[30px] md:text-[40px] font-extrabold'>{courseData?.title}</h2>
            <p className='mt-[10px] text-[18px] md:text-[20px] text-[#7D7D7D] md:w-[45ch] lg:w-[60ch]'>{courseData?.longDesc}</p>
            <button className='block mx-[auto] md:mx-[0px] my-[20px] font-bold text-[16px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]' onClick={scrollToContact}> Enroll Now </button>
        </div>
        <div className='row-[2_/_4] col-[1_/_2] flex flex-wrap md:flex-nowrap gap-y-[16px] gap-x-[21px] md:px-[32px]'>
            {headerExtraDetails?.map((extraDetail:HeaderExtraDetailsType)=>
            <div className='md:h-[180px] w-[100%] md:w-[200px] flex flex-col md:items-center justify-center px-[24px] py-[15px] md:text-center rounded-[25px]' 
                    style={{backgroundColor: extraDetail?.bgColor}} key={extraDetail?.id}>
                <h3 className='text-[20px] md:text-[26px] font-extrabold' style={{color: extraDetail?.fontColor}}>{extraDetail?.detailHeading}</h3>
                <p className='text-[16px] text-[#7d7d7d]'>{extraDetail?.detailDescription}</p>
            </div>)}
        </div>
    </div>
}
export default Header